export default "__VITE_ASSET__a2865475__"